<template>
  <div>
    <!-- <button @click="signinRedirect">Войти через ЕСИА</button> -->
  </div>
</template>

<script>
import userManager from "@/modules/auth/user-manager";

export default {
  name: "Login",
  created() {
    this.signinRedirect();
  },
  methods: {
    signinRedirect() {
      const returnUrl = this.$route.query.returnUrl;
      const error = this.$route.query.error;
      const storageKey = "login_return_url";
      if (returnUrl) {
        sessionStorage.setItem(storageKey, returnUrl);
      } else {
        sessionStorage.removeItem(storageKey);
      }
      userManager.signinRedirect({
        extraQueryParams: {
            base_url: window.location.origin,
            error: error ?? ""            
        },
      });
    },
  },
};
</script>